import React, { useEffect } from 'react';
import { API_BASE } from '../config';

export default function LogoutPage({ onDone }) {
  useEffect(() => {
    const run = async () => {
      try {
        await fetch(`${API_BASE}/auth/logout`, { method: 'POST', credentials: 'include' });
      } catch (e) {}
      if (onDone) onDone();
    };
    run();
  }, [onDone]);
  return <div style={{ marginTop: 20 }}>Logging out…</div>;
}


